import api from '@/ts/api';
import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

export const Roots = defineStore('roots', {
  state: () => ({
    list: useStorage('stima_roots', []),     
  }),
  
  getters: {
    all: (state) => state.list.length ? state.list.sort((a, b) => a.title.localeCompare(b.title)) || [] : [],            
    active: (state) => state.all.filter(item => item.active) || [],    
    inactive: (state) => state.all.filter(item => !item.active) || [],        
    sid: (state) => (sid) => state.all.find((item) => item.sid == sid) || {},
    get: (state) => (id) => state.all.find(item => item.id == id) || {},    
    title: (state) => (id) => state.get(id).title || 'Empty',    
    meta: (state) => (id) => state.get(id).meta || {},    
    field: (state) => (root, k) => state.meta[k],    
    macrocategory: (state) => {
      let list = []
      let un = {}
      state.all.forEach(item => {
        if (!item || !item.meta || !item.meta['settings/macro']) return
        if (un[item.meta['settings/macro']]) return
        list.push(item.meta['settings/macro'])
        un[item.meta['settings/macro']] = true
      });

      return list.sort((a, b) => a.localeCompare(b))
    },    
    macroRoots: (state) => (name) => {
      let list = []      
      state.all.forEach(item => {
        if (!item || !item.meta || !item.meta['settings/macro']) return
        let macro = item.meta['settings/macro']
        if (macro != name) return
        list.push(item)        
      });
      return list.sort((a, b) => a.title.localeCompare(b.title))
    },    
    macroRootsAssetsCount: (state) => (name) => {
      let count = 0
      let list = []
      state.all.forEach(item => {
        if (!item || !item.meta || !item.meta['settings/macro']) return
        let macro = item.meta['settings/macro']
        if (macro != name) return
        count += item.count || 0        
      });
      return count
    },    

    macroRootless: (state) => {
      let list = []      
      state.all.forEach(item => {
        if (!item || !item.meta) return
        if (item.meta['settings/macro']) return
        list.push(item)
      });
      return list.sort((a, b) => a.title.localeCompare(b.title))
    },    
  },
  
  actions: {
  
    async refresh(){
        // if (this.list.length) return
        this.force()
   },
    
   async force(){        
        let res = await api.send('dict/roots',{})
        if (res.error) return
        this.list = res.resp || []        
        this.list.forEach(item => {
          item.meta = item.meta || {}
          item.count = item.meta.assets_count
          item.sum = item.meta.assets_sum
        });
   },

    async create(list){
        let res = await api.send('admin/roots/create',{list})
        if (res.error) return res    
        this.force()    
        return res
    },
      
    async update(id, k, v){
        let res = await api.send('admin/roots/update',{id, k, v})
        if (res.error) return res
        this.force()
        return res
    },
    
    async updateMeta(id, k, v){
        let res = await api.send('admin/roots/update/meta',{id, k, v})
        if (res.error) return res
        this.force()
        return res
    },

      async delete(id){
        let res = await api.send('admin/roots/delete',{id})
        if (res.error) return res      
        this.force()
        return res
    },

    clear(){
      this.list = []      
    },
     
  },



})

